export default "__VITE_ASSET__BGighzWT__"